module.exports = __webpack_public_path__ + "img/about-01.e83b9d7d.png";